import React from "react";
import styles from "./sidebar.module.less"
import Nav from "../nav/nav.component";
function Sidebar(props){

    return (
        <div className={`${styles.sidebar} ${props.isClosed ? styles.closed : ''}`}>
            <h2>
                {props.fullname}
            </h2>
            <div id={styles.burhan}></div>
            <p id={styles.description}>
                {props.whoAmI}
            </p>
            <div id={styles.sidebarCollapseBtn} onClick={props.toggle}>
                <div></div>
            </div>
           
            <Nav />

            <div id={styles.contact}>
                <b>Get in touch with me:</b>
                <div id={styles.message}>
                    <img src="/images/icon-msg.png" />
                    <a href={`mailto:${props.email}`}>{props.email}</a>
                </div>
                <div id={styles.socs}>
                    <a href={props.linkedinURI} target="_blank"><i className="icon icon-linkedin-squared"></i></a>
                    <a href={props.githubURI} target="_blank"><i className="icon icon-github-circled-alt2"></i></a>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;